import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

gsap.registerPlugin(ScrollTrigger);



/*--------------------フロントページ　swipper -------------------*/
const initIndexBlogSwiper = async () => {
  const swiperElement = document.querySelector('.index_blog_swiper');

  if (!swiperElement) {
    return;
  }

  const { default: Swiper } = await import(
    /* webpackIgnore: true */ 'swiper'
  );

  // let paginationElement = swiperElement.querySelector('.swiper-pagination');

  // // front-page.phpにpagination要素がない場合はJSで補完する
  // if (!paginationElement) {
  //   paginationElement = document.createElement('div');
  //   paginationElement.className = 'swiper-pagination index_blog_pagination';
  //   swiperElement.appendChild(paginationElement);
  // }

  new Swiper(swiperElement, {
    slidesPerView: 3.5,
    spaceBetween: 12,
    loop: true,
    speed: 800,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  // ここで自作のクラス名を紐付ける！
    navigation: {
      nextEl: '.swiper-btn-next',
      prevEl: '.swiper-btn-prev',
    },
  });
};

/*---------- front-page 商品セクション GSAP演出 -------------- */
const initIndexProductScrollAnimation = () => {
  const section = document.querySelector('.index_product_section');
  const slide01 = section?.querySelector('.index_product_slide_01');
  const slide02 = section?.querySelector('.index_product_slide_02');
  const titleWrap = section?.querySelector('.index_product_ttl_wrap');
  const titleInner = section?.querySelector('.index_product_ttl_inner');

  if (!section || !slide01 || !slide02 || !titleWrap || !titleInner) {
    return;
  }

  const media = gsap.matchMedia();

  media.add('(min-width: 769px)', () => {
    gsap.set(slide02, { y: 120, autoAlpha: 1 });
    gsap.set(titleWrap, { autoAlpha: 1, clearProps: 'transform' });
    gsap.set(titleInner, { autoAlpha: 1, clearProps: 'transform,filter' });

    const fixedTitleTrigger = ScrollTrigger.create({
      trigger: slide01,
      start: 'top 106px',
      endTrigger: slide02,
      end: 'top 106px',
      markers: true,
      invalidateOnRefresh: true,
      onEnter: () => titleWrap.classList.add('is_fixed'),
      onEnterBack: () => titleWrap.classList.add('is_fixed'),
      onLeave: () => titleWrap.classList.remove('is_fixed'),
      onLeaveBack: () => titleWrap.classList.remove('is_fixed'),
    });

    const slide02Timeline = gsap.timeline({
      scrollTrigger: {
        trigger: slide02,
        start: 'top 80%',
        end: 'top 106px',
        scrub: 1,
        markers: true,
        invalidateOnRefresh: true,
      },
    });

    slide02Timeline
      .to(slide02, {
        y: 0,
        ease: 'none',
      }, 0)
      .to(titleInner, {
        autoAlpha: 0,
        y: -24,
        scale: 0.96,
        filter: 'blur(8px)',
        ease: 'none',
      }, 0.45)
      .to(titleWrap, {
        autoAlpha: 0,
        ease: 'none',
      }, 0.7);

    return () => {
      fixedTitleTrigger.kill();
      slide02Timeline.scrollTrigger?.kill();
      slide02Timeline.kill();
    };
  });
};

/*---------- header スクロールがminimgを超えたらクラス付与　-------------- */
const headerScrollEffect = () => {
  const header = document.querySelector('.header');
  const mainimg = document.querySelector('.mainimg');

  if (!header || !mainimg) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          header.classList.add('is_active');
        } else {
          header.classList.remove('is_active');
        }
      });
    },
    {
      threshold: 0,
      rootMargin: '0px',
    }
  );

  observer.observe(mainimg);
};


/*---------- menuボタン　開閉　-------------- */
const initHeaderMenuToggle = () => {
  const header = document.querySelector('.header');
  const menuBtn = document.querySelector('.menu_btn');
  const headerContents = document.querySelector('.header_contents');

  if (!header || !menuBtn || !headerContents) {
    return;
  }

  const headerContentsId = 'header-contents';
  headerContents.id = headerContentsId;
  menuBtn.setAttribute('role', 'button');
  menuBtn.setAttribute('tabindex', '0');
  menuBtn.setAttribute('aria-controls', headerContentsId);
  menuBtn.setAttribute('aria-expanded', 'false');

  const setMenuState = (isOpen) => {
    header.classList.toggle('is_menu_open', isOpen);
    menuBtn.classList.toggle('is_active', isOpen);
    menuBtn.setAttribute('aria-expanded', String(isOpen));
    document.body.classList.toggle('is_menu_open', isOpen);
  };

  const toggleMenu = () => {
    setMenuState(!header.classList.contains('is_menu_open'));
  };

  menuBtn.addEventListener('click', toggleMenu);
  menuBtn.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleMenu();
    }
  });

  headerContents.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      if (window.innerWidth <= 1600) {
        setMenuState(false);
      }
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1600) {
      setMenuState(false);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  initIndexBlogSwiper();
  initIndexProductScrollAnimation();
  initHeaderMenuToggle();
  headerScrollEffect();
});

/*---------- contactページ　バリデーション-------------- */
 if (document.body.classList.contains('contact')){
  topValidation();
 };

